// extracted by mini-css-extract-plugin
module.exports = {"title":"SuggestionsComplains_title__ioKx8","para":"SuggestionsComplains_para__2uJ_9"};